export default __webpack_public_path__ + "static/img5-523da1ecf9acd17beccdc85dad111672.png";